export const pageHead = (metadata: {
  title: string;
  canonicalUrl: any;
  description: string;
  previewImage: any;
  noindex: boolean;
}) => {
  const route = useRoute();
  const config = useRuntimeConfig().public;

  useSeoMeta({
    title: metadata.title,
    ogTitle: metadata.title,
    description: metadata.description,
    ogDescription: metadata.description,
    ogImage: metadata.previewImage?.filename || null,
    twitterCard: metadata.previewImage?.filename || null,
    ogUrl:
      config.siteURL + (getStoryblokUrl(metadata.canonicalUrl) || route.path),
    robots:
      Object.keys(route.query).length > 0 || metadata.noindex
        ? "noindex, nofollow"
        : "index, follow",
  });
};
